import { Component, OnInit, Input } from '@angular/core';
import { MbIconModule } from '@am/moebius';
import { NgIf, NgFor } from '@angular/common';
import { CardInfoDetailV2Component } from '../card-info-detail-v2/card-info-detail-v2.component';

@Component({
    selector: 'amenities',
    templateUrl: './amenities.component.html',
    styleUrls: ['./amenities.component.scss'],
    standalone: true,
    imports: [
        CardInfoDetailV2Component,
        NgIf,
        NgFor,
        MbIconModule,
    ],
})
export class AmenitiesComponent implements OnInit {
  @Input() amenities: any[];
  @Input() isDisney: boolean;

  showButton = false;

  moreAmenities = [];
  lessAmenities = [];

  ngOnInit() {
    if (this.amenities.length > 5) {
      this.showButton = true;
      this.moreAmenities = this.amenities;
      this.lessAmenities = this.amenities.slice(0, 5);
      this.onClickViewMoreLess(true);
    }
  }

  onClickViewMoreLess(viewLess) {
    this.amenities = viewLess ? this.lessAmenities : this.moreAmenities;
  }
}
